export const templateMixin = {
  methods: {
    getStatus(status, linkedDevices) {
      const hasLinkedDevices = linkedDevices === true || linkedDevices > 0;
      const hasStatus = !!status && typeof status === 'object';
      switch (true) {
        case !hasLinkedDevices:
          return {
            text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.statuses.noLinkedDevices'),
            color: '#b4b3b4',
          };
        case !hasStatus:
          return {
            text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.statuses.allDevicesAreSynced'),
            color: '#50d82a',
          };
        case (!status.isRunning && status.syncFailed === false) ||
          (!status.isRunning && status.lastSyncTime === null && status.syncFailed === undefined):
          return {
            text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.statuses.allDevicesAreSynced'),
            color: '#50d82a',
          };
        case !status.isRunning && status.syncFailed === true:
          return {
            text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.statuses.syncFailed'),
            color: '#ec7f8c',
          };
        case status.isRunning === true:
          return {
            text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.statuses.syncInProgress'),
            color: '#43b6ea',
          };
        default:
          throw new Error('DEVICE_TEMPLATE_STATUS_NOT_VALID');
      }
    },
  },
};
